module.exports = {
  title: "聚沙成塔管理系统",

  /**
   * @type {boolean} true | false
   * @description 固定头部，暂时不用
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description 左侧LOGO显示问题，暂时不用
   */
  sidebarLogo: false
}
